import React, { useEffect, useState } from 'react';

import {
    StyledPurpleContainer,
    StyledTwoScreensWrapper,
} from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTip } from '@/operator/components/modules/AuthPage/setup/MessageWithTip';
import { Content } from './BuildContent';
import { Work } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useOrgNavigate } from "app/routes/useOrgNavigate";

import { useHandleUserSessionData } from '@/operator/hooks/useHandleUserSessionData';
import { ROUTES } from '@/routes/constants';

const BuildPage = (): JSX.Element => {
    const [isSessionValid, setIsSessionValid] = useState(false);
    const { t } = useTranslation();
    const navigate = useOrgNavigate();

    const { checkSessionDataIntegrity } = useHandleUserSessionData();

    useEffect(() => {
        const sessionIsValid = checkSessionDataIntegrity();
        if (!sessionIsValid) {
            navigate(ROUTES.AUTH_SETUP_ONBOARDING);
        }
        setIsSessionValid(sessionIsValid);
    }, []);

    if (!isSessionValid) {
        return <></>;
    }

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTip
                Icon={Work}
                headline={t('Auth.Setup.Build.Content.Header')}
                description={t('Auth.Setup.Build.Content.Description')}
            />

            <StyledPurpleContainer>
                <Content />
            </StyledPurpleContainer>
        </StyledTwoScreensWrapper>
    );
};

export default BuildPage;
